import { filterEmptyFields } from '@/utils/filterEmptyFields'

type SelectedFileType = File | undefined | 'removeImage'

interface BuildFormDataWithImageOptions {
  selectedFile: SelectedFileType
  data: Record<string, any>
  imageFieldName?: string
  dataFieldName?: string
  filterData?: boolean
}

export const buildFormDataWithImage = ({
  selectedFile,
  data,
  imageFieldName = 'imageBuffer',
  dataFieldName = 'data',
  filterData = true,
}: BuildFormDataWithImageOptions): FormData => {
  const formData = new FormData()

  if (selectedFile && selectedFile !== 'removeImage') {
    formData.append(imageFieldName, selectedFile)
  }

  const processedData = filterData ? filterEmptyFields(data) : data
  formData.append(dataFieldName, JSON.stringify(processedData))

  formData.append('removeImage', String(selectedFile === 'removeImage'))

  return formData
}
